<template>
  <div id="eds">
    <RouterView />
  </div>
</template>

<script setup>
import { useRedirectToError } from '@/composables/useRedirectToError'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAuthStore } from '@/stores/authenticated/AuthStore'
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterView, useRouter } from 'vue-router'

const { t } = useI18n()
const callerPath = 'app'

const router = useRouter()
const authStore = useAuthStore()

watch(
  () => authStore.isAuthenticated,
  (isAuthenticated) => {
    if (!isAuthenticated && !authStore.isLoggingOut) {
      useRedirectToError(router)
        .setTitle(t(useTranslationPath(callerPath, 'sessionExpired')))
        .setMessage(t(useTranslationPath(callerPath, 'sessionExpiredDescription')))
        .setStatus(403)
        .redirect()
    }
  },
  {
    immediate: false,
    deep: true,
  },
)
</script>
